import { Box, Text } from '@domain-group/suit-theme'

import type { ArtworkPageDataChange } from '@domain-group/realhub-backend-api-types'

import Change from './Change'

interface PageDataChangesProps {
  callbacks: object,
  disableItemSync?: boolean,
  page: {
    changes: ArtworkPageDataChange[],
    id: number,
    templatePageId: number,
    title: string,
  },
}

const PageDataChanges = (props: PageDataChangesProps) => {
  const {
    callbacks,
    disableItemSync = false,
    page: {
      changes,
      id,
      templatePageId,
      title,
    },
  } = props

  if (!changes.length) return null

  return (
    <Box flexDirection="column" paddingY="large">
      <Text
        borderBottom="1px dashed"
        borderColor="lineColor"
        color="bodyFontLightColor"
        fontSize="xsmall"
        fontWeight="bold"
        paddingBottom="small"
      >
        {title} | Template #{templatePageId}
      </Text>

      {changes.map(change => (
        <Change
          artworkPageId={id}
          // @ts-expect-error TS2741
          callbacks={callbacks}
          change={change}
          disableSync={disableItemSync}
          key={change.id}
        />
      ))}
    </Box>
  )
}

export default PageDataChanges
